import { computed } from 'vue'
import { useCodesStore } from '@/ContextTab/stores/codes/codes'


// TODO: Потенциально вызывает большое потребление памяти
export function useRepublishCodes({
  lang = 'RU',
  omit,
}: {
  lang: string | undefined
  omit?: (number | string)[]
}) {
  const codesStore = useCodesStore()

  const itemsByUid = computed(() => {
    const codes = lang === 'RU'
      ? codesStore.codesAvailableForRepublicationByUid?.ru
      : codesStore.codesAvailableForRepublicationByUid?.en

    if (!omit?.length) {
      return codes
    }

    if (codes) {
      return Object.keys(codes)
        .filter((uid) => codes[uid] && !omit.includes(Number(codes[uid].id)))
        .reduce((acc, uid) => {
          acc[uid] = codes[uid]
          return acc
        }, {} as any)
    }

    return {}
  })

  return {
    items: itemsByUid,
  }
}
